import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ChatList from "./components/ChatList/ChatList";
import ChatWindow from "./components/ChatWindow/ChatWindow";
import { FiMessageCircle } from "react-icons/fi";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const MessagesPage = () => {
  const [selectedChatId, setSelectedChatId] = useState(null);
  const [chatPartnerInfo, setChatPartnerInfo] = useState(null);
  const [showMobileChatList, setShowMobileChatList] = useState(false);
  const [shouldAutoSelectFirstChat, setShouldAutoSelectFirstChat] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const navigate = useNavigate();
  const { username } = useParams();

  const goHome = () => navigate(`/${username}/explore`);

  // ✅ Reliable isMobile logic using matchMedia
  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    setIsMobile(mediaQuery.matches);
    const handleChange = (e) => setIsMobile(e.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    console.log("📱 isMobile:", isMobile);
  }, [isMobile]);

  const refreshUnreadCount = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${BACKEND_URL}/chats`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      const currentUserEmail = localStorage.getItem("userEmail");
      const totalUnread = data.chats.reduce((sum, chat) => {
        const isMe = chat.lastSender === currentUserEmail;
        return sum + (!isMe ? (chat.unreadCount || 0) : 0);
      }, 0);
      localStorage.setItem("unreadMessagesCount", totalUnread);
    } catch (err) {
      console.error("❌ Error refreshing unread count", err);
    }
  };

  useEffect(() => {
  refreshUnreadCount();

  if (!selectedChatId) {
    setShouldAutoSelectFirstChat(true); // 💯 Always set it
    if (isMobile) {
      setShowMobileChatList(true);
    }
  }
}, [isMobile, selectedChatId]);


  const handleSelectChat = async (chatId) => {
    setSelectedChatId(chatId);
    refreshUnreadCount();
    if (isMobile) setShowMobileChatList(false);

    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${BACKEND_URL}/chats`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      const currentUserEmail = localStorage.getItem("userEmail");
      const chat = data.chats.find((c) => c.chatId === chatId);
      const otherEmail = chat.participants.find((e) => e !== currentUserEmail);
      const userRes = await fetch(`${BACKEND_URL}/user/${encodeURIComponent(otherEmail)}`);
      const userData = await userRes.json();

      setChatPartnerInfo({
        name: `${userData.firstName || ""} ${userData.lastName || ""}`.trim() || otherEmail.split("@")[0],
        profileImage: userData.profileImage || "/person.png",
      });
    } catch (err) {
      console.error("❌ Error loading chat partner info", err);
      setChatPartnerInfo(null);
    }
  };

  const handleBack = () => {
    setShowMobileChatList(true);
    setSelectedChatId(null);
  };

  return (
    <div className="h-screen flex overflow-hidden bg-white relative">
      {isMobile && !showMobileChatList && (
        <button
          onClick={() => {
            setShouldAutoSelectFirstChat(true);
            setShowMobileChatList(true);
          }}
          className="fixed bottom-4 left-4 z-50 bg-white/40 backdrop-blur-md border border-white/20 text-gray-700 hover:bg-white/60 p-2 rounded-full shadow-md transition-all"
        >
          <FiMessageCircle size={20} />
        </button>
      )}

      {!isMobile && (
        <div className="w-[36%] xl:w-[30%] 2xl:w-[28%] border-r border-gray-200">
          <ChatList
            selectedChatId={selectedChatId}
            onSelectChat={handleSelectChat}
            onInitialLoad={(firstChatId) => {
  console.log("🧪 onInitialLoad — firstChatId:", firstChatId);
  console.log("🧪 shouldAutoSelectFirstChat:", shouldAutoSelectFirstChat);
  console.log("🧪 selectedChatId:", selectedChatId);

  if (shouldAutoSelectFirstChat && !selectedChatId) {
    handleSelectChat(firstChatId);
    setShouldAutoSelectFirstChat(false);
  }
}}

          />
        </div>
      )}

      {isMobile && showMobileChatList && (
        <>
          <div
            className="fixed inset-0 bg-black bg-opacity-30 z-30"
            onClick={() => setShowMobileChatList(false)}
          />
          <div className="fixed top-0 left-0 w-4/5 h-full bg-white shadow-lg z-40 overflow-y-auto transition-transform duration-300">
            <ChatList
              selectedChatId={selectedChatId}
              onSelectChat={handleSelectChat}
              onInitialLoad={(firstChatId) => {
  console.log("🧪 onInitialLoad — firstChatId:", firstChatId);
  console.log("🧪 shouldAutoSelectFirstChat:", shouldAutoSelectFirstChat);
  console.log("🧪 selectedChatId:", selectedChatId);

  if (shouldAutoSelectFirstChat && !selectedChatId) {
    handleSelectChat(firstChatId);
    setShouldAutoSelectFirstChat(false);
  }
}}

            />
          </div>
        </>
      )}

      <div
        className={`
          ${isMobile && showMobileChatList ? "hidden" : "flex"}
          w-full ${!isMobile ? "md:w-[64%] xl:w-[70%] 2xl:w-[72%]" : ""}
          flex-col bg-gray-50
        `}
      >
        <div className="flex flex-col h-screen overflow-hidden min-h-0">
          <ChatWindow
            key={selectedChatId || "no-chat"}
            chatId={selectedChatId}
            chatPartnerInfo={chatPartnerInfo}
            onMessagesSeen={refreshUnreadCount}
            onBack={isMobile ? handleBack : null}
          />
        </div>
      </div>
    </div>
  );
};

export default MessagesPage;
